var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoolLightBox',{attrs:{"items":_vm.images,"fullScreen":true,"index":_vm.openedImageIndex},on:{"close":function () { return _vm.$emit('close'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }